import { jsx as r, jsxs as g } from "react/jsx-runtime";
import { useTranslation as me, PaymentMethodEnum as ce, getPaymentMethodTitle as ue, ContactSlugEnum as de, FieldErrorAndDescription as pe } from "@systemeio/ui";
import { useWatch as n } from "@systemeio/util";
import fe from "isomorphic-dompurify";
import { useState as T } from "react";
import he from "../../../components/layout.mjs";
import ge from "../../../components/store-image.mjs";
import ye from "../../../components/affiliate-badge.mjs";
import Pe from "../../../components/field.mjs";
import be from "../../../components/full-screen-card-wrapper.mjs";
import { PaymentMethodIcon as Ce } from "../../../components/payment-method-icon.mjs";
import { usePaymentProcessors as Me } from "../../../payment-processors/index.mjs";
import { usePhysicalProductStore as xe, useOfferStore as Ee } from "../../../store/index.mjs";
import { getDeepCopiedObject as Fe } from "../../../utils/get-deep-copied-object.mjs";
import { getDefaultFieldValues as Oe } from "../../../utils/get-default-field-values.mjs";
import { hasErrors as je } from "../../../utils/has-errors.mjs";
import { parseErrors as De } from "../../../utils/parse-errors.mjs";
import { offerDefaultErrors as p } from "../constants/default-errors.mjs";
import { useCatchCookiePurchaseError as Ie } from "../hooks/use-catch-cookie-purchase-error.mjs";
import { getDefaultCoverByProductType as Ne } from "../utils/get-default-cover-by-type.mjs";
import { getMissingFieldsErrors as Te } from "../utils/get-missing-fields-errors.mjs";
import { OrderSummary as ke } from "./components/order-summary/index.mjs";
import { ProductCard as ve } from "./components/product-card/index.mjs";
import { ShippingMethod as Se } from "./components/shipping-method/index.mjs";
import { getPhysicalProductPricePlan as k } from "./utils/get-physical-product-price-plan.mjs";
import _e from "../../../ui-kit/radio-group/radio-group-accordion.mjs";
const nt = (y) => {
  var I;
  const { title: M, description: v, buttonTitle: S, fields: _, cover: P, offerId: b, id: x } = y.checkoutPage, {
    currency: A,
    paymentMethods: L,
    thankYouPage: C,
    affiliateLink: R,
    displayAffiliateLink: q,
    productType: w,
    physicalProduct: o,
    shippingRules: B,
    calculatePrice: H,
    isLoadingShippingRules: W = !1,
    isLoadingCalculatePrice: U = !1,
    skipDisabledButton: $ = !1
  } = y, { t: l } = me(), [z, G] = T(!1), [m, c] = T(p), { productVariant: u, quantity: V, selectedShipping: a } = xe();
  Ie({
    handlerError: (e) => c((t) => ({ ...t, common: [e] })),
    pagePath: y.checkoutPage.path
  });
  const {
    availablePaymentMethods: E,
    setAvailablePaymentMethods: J,
    setPaymentMethod: K,
    paymentMethod: f,
    setCurrency: Q,
    setPricePlan: F,
    setOfferId: X,
    setProductId: Y,
    finalAmount: Z,
    setFinalAmount: O,
    contactFields: s,
    setContactFields: j
  } = Ee();
  n(o == null ? void 0 : o.id, (e) => e && Y(e)), n(b, (e) => e && X(e)), n(L, (e) => e && J(e)), n(A, (e) => e && Q(e)), n(_, (e) => e && j(Oe(e))), n(o, (e) => {
    if (!e)
      F(void 0), O(void 0);
    else {
      const t = k(e, u);
      t && (F(t), O(t.amount));
    }
  });
  const ee = () => {
    let e = !1;
    const t = Fe({
      customer: p.customer,
      paymentMethod: p.paymentMethod
    });
    return Object.values(s).forEach(({ slug: i, value: d, required: h }) => {
      h && (d == null || d === "") && (t.customer.fields[i] = [l("public_pages_purchase.required-field")], e = !0);
    }), f || (t.paymentMethod = [l("public_pages_purchase.required-field")], e = !0), { errors: t, isFailed: e };
  }, D = !!Z && !!f && !!b && !!o && !!x, te = () => {
    if (!D) return;
    const e = k(o, u);
    if (!e) return;
    const t = Object.values(s).reduce((h, N) => (h[N.slug] = N.value ?? "", h), {}), i = `${window.location.origin}${(C == null ? void 0 : C.path) ?? ""}`, d = window.location.href;
    return {
      page: x,
      customer: {
        fields: t
      },
      offer: b,
      digitalProduct: null,
      pricePlan: e.id,
      purchaseProductModel: {
        product: o.id,
        productVariant: (u == null ? void 0 : u.id) ?? null,
        quantity: V,
        shippingRule: (a == null ? void 0 : a.ruleId) ?? null,
        shippingCondition: (a == null ? void 0 : a.conditionId) ?? null
      },
      thankYouPageUrl: i,
      failedReturnUrl: d,
      paymentMethod: f
    };
  }, re = () => {
    c(p);
    const { errors: e, isFailed: t } = ee();
    if (t) {
      c((i) => ({ ...i, ...e }));
      return;
    }
    return te();
  }, oe = (e) => {
    const t = De(e, p), i = Te(t.customer.fields, s);
    c({
      ...t,
      common: t.common.concat(i)
    });
  }, { paymentProcessorPaymentButton: se, paymentProcessorDetails: ie, PaymentProcessorProvider: ae } = Me({
    isFetching: z,
    setIsFetching: G,
    handleBadRequest: oe,
    buttonTitle: S,
    buttonDisabled: !D && !$,
    preSubmit: re,
    setErrors: c,
    hasErrors: je(m)
  }), ne = Object.values(E).filter((e) => e !== ce.stripe_applepay).map((e) => ({
    id: e,
    caption: l(ue(e, l)),
    content: ie,
    additionalInfo: /* @__PURE__ */ r(Ce, { paymentMethod: e })
  })), le = (e, t) => {
    j({
      ...s,
      [e.slug]: { ...e, value: t }
    });
  };
  return /* @__PURE__ */ r(he, { children: /* @__PURE__ */ g(be, { children: [
    /* @__PURE__ */ g("form", { className: "flex flex-col gap-5 px-5 pt-5 sm:gap-10 sm:pb-5 ", children: [
      /* @__PURE__ */ r(
        ge,
        {
          className: "h-full w-full shrink-0 rounded-lg",
          src: P == null ? void 0 : P.path,
          imageType: Ne(w),
          alt: M
        }
      ),
      /* @__PURE__ */ r("h2", { className: "text-xl font-bold sm:text-3xl", children: M }),
      /* @__PURE__ */ g("div", { className: "flex flex-col gap-3 sm:gap-5", children: [
        /* @__PURE__ */ r(
          "div",
          {
            className: "ckeditor-default text-sm sm:text-base sm:leading-5",
            dangerouslySetInnerHTML: {
              __html: fe.sanitize(v)
            }
          }
        ),
        o && /* @__PURE__ */ r(ve, { product: o }),
        s[de.Country] && /* @__PURE__ */ r(Se, { shipping: B, isLoading: W }),
        o && /* @__PURE__ */ r(
          ke,
          {
            product: o,
            calculatePrice: H,
            isLoading: U
          }
        ),
        Object.values(s).map((e) => /* @__PURE__ */ r(
          Pe,
          {
            contactFields: s,
            field: e,
            value: s[e.slug].value,
            error: m.customer.fields[e.slug],
            onChange: (t) => le(e, t)
          },
          e.slug
        )),
        /* @__PURE__ */ g(ae, { children: [
          E.length > 0 && /* @__PURE__ */ r(
            _e,
            {
              label: l("public_pages_purchase.Payment-method"),
              labelClassName: "mb-2",
              optionClassName: "text-THEME-text-secondary",
              selectedOptionClassName: "text-THEME-text-secondary",
              optionsWrapperClassName: "gap-3",
              options: ne,
              selected: f,
              onChange: (e) => K(e),
              required: !0,
              error: (I = m.paymentMethod) == null ? void 0 : I.join(", ")
            }
          ),
          m.common && /* @__PURE__ */ r(
            pe,
            {
              error: m.common.join(", "),
              errorClassName: "flex justify-center"
            }
          ),
          se
        ] })
      ] })
    ] }),
    q && /* @__PURE__ */ r(ye, { affiliateLink: R })
  ] }) });
};
export {
  nt as PhysicalCheckout,
  k as getPhysicalProductPricePlan
};
